export const getPrintTemplate = (values) => {
  const {
    unit = "",
    address = "",
    accountNumber = "",
    monthYear = "",
    details = [],
    totalOpeningBalance = 0,
    totalInwardAmount = 0,
    totalOutwardAmount = 0,
    totalClosingBalance = 0,
    signingDay = "",
    signingMonth = "",
    signingYear = "",
    ledgerClerk = "",
    chiefAccountant = "",
    legalRepresentative = "",
  } = values;

  const fmt = (n) => (n && n !== 0 ? new Intl.NumberFormat("vi-VN").format(n) : "0");

  let tableRows = details.map((item) => `
    <tr>
      <td class="border text-center">${item.ordinalNumber || ""}</td>
      <td class="border px-1">${item.name || ""}</td>
      <td class="border text-right px-1">${fmt(item.openingBalance)}</td>
      <td class="border text-right px-1">${fmt(item.inwardAmount)}</td>
      <td class="border text-right px-1">${fmt(item.outwardAmount)}</td>
      <td class="border text-right px-1">${fmt(item.closingBalance)}</td>
    </tr>
  `).join("");

  return `
    <div style="font-family: 'Times New Roman', Times, serif; font-size: 13px; color: black; line-height: 1.5;">
      <table width="100%">
        <tr>
          <td width="50%" valign="top">
            <div class="font-bold">Đơn vị: <span style="font-weight: normal; border-bottom: 1px dotted black;">${unit}</span></div>
            <div class="font-bold">Địa chỉ: <span style="font-weight: normal; border-bottom: 1px dotted black;">${address}</span></div>
          </td>
          <td width="50%" align="center">
            <div class="font-bold">Mẫu số S11-DN</div>
            <div style="font-style: italic; font-size: 12px;">(Kèm theo Thông tư số 99/2025/TT-BTC <br/> ngày 27 tháng 10 năm 2025 của Bộ trưởng Bộ Tài chính)</div>
          </td>
        </tr>
      </table>

      <div style="text-align: center; margin: 20px 0;">
        <h2 style="margin: 0; text-transform: uppercase; font-size: 18px;">BẢNG TỔNG HỢP CHI TIẾT VẬT LIỆU, DỤNG CỤ, SẢN PHẨM, HÀNG HÓA</h2>
        <div style="margin-top: 10px; font-weight: bold;">Tài khoản: ${accountNumber}</div>
        <div style="margin-top: 5px;">Tháng: ${monthYear}</div>
      </div>

      <table class="table-full" width="100%" style="border-collapse: collapse; margin-top: 15px;">
        <thead>
          <tr>
            <th class="border" rowspan="2" width="50">STT</th>
            <th class="border" rowspan="2">Tên, quy cách vật liệu, dụng cụ, sản phẩm, hàng hóa</th>
            <th class="border" colspan="4">Số tiền</th>
          </tr>
          <tr>
            <th class="border" width="110">Tồn đầu kỳ</th>
            <th class="border" width="110">Nhập trong kỳ</th>
            <th class="border" width="110">Xuất trong kỳ</th>
            <th class="border" width="110">Tồn cuối kỳ</th>
          </tr>
          <tr bgcolor="#F0F0F0">
            <th class="border">A</th>
            <th class="border">B</th>
            <th class="border">1</th>
            <th class="border">2</th>
            <th class="border">3</th>
            <th class="border">4</th>
          </tr>
        </thead>
        <tbody>
          ${tableRows}
          <tr style="font-weight: bold; background-color: #fafafa;">
            <td class="border text-center" colspan="2">Cộng</td>
            <td class="border text-right px-1">${fmt(totalOpeningBalance)}</td>
            <td class="border text-right px-1">${fmt(totalInwardAmount)}</td>
            <td class="border text-right px-1">${fmt(totalOutwardAmount)}</td>
            <td class="border text-right px-1">${fmt(totalClosingBalance)}</td>
          </tr>
        </tbody>
      </table>

      <table width="100%" style="margin-top: 30px; text-align: center;">
        <tr>
          <td width="30%">
            <div class="font-bold">Người ghi sổ</div>
            <div style="font-style: italic; font-size: 11px;">(Ký, họ tên)</div>
            <div style="margin-top: 60px;" class="font-bold">${ledgerClerk}</div>
          </td>
          <td width="30%">
            <div class="font-bold">Kế toán trưởng</div>
            <div style="font-style: italic; font-size: 11px;">(Ký, họ tên)</div>
            <div style="margin-top: 60px;" class="font-bold">${chiefAccountant}</div>
          </td>
          <td width="40%">
            <div style="font-style: italic; font-size: 12px; margin-bottom: 5px;">Ngày ${signingDay} tháng ${signingMonth} năm ${signingYear}</div>
            <div class="font-bold">Người đại diện theo pháp luật</div>
            <div style="font-style: italic; font-size: 11px;">(Ký, họ tên, đóng dấu)</div>
            <div style="margin-top: 60px;" class="font-bold">${legalRepresentative}</div>
          </td>
        </tr>
      </table>

      <style>
        .border { border: 1px solid black; }
        .text-center { text-align: center; }
        .text-right { text-align: right; }
        .font-bold { font-weight: bold; }
        .px-1 { padding: 6px; }
        .table-full { border: 1px solid black; }
        .dotted-line { border-bottom: 1px dotted black; padding: 0 10px; }
      </style>
    </div>
  `;
};
